export default "__VITE_ASSET__1gM1pdpv__"